<template>
  <div>
    <div class="filter" style="border-bottom: 2px solid #335667">
      <el-form
        :model="filter"
        ref="filterForm"
        label-width="60px"
        label-position="top"
      >
        <el-form-item label="流程">
          <ServiceQuestFlowSelect
            v-model="filter.flow_id"
            @info="
              filter.step_ids = []
              getData()
            "
          ></ServiceQuestFlowSelect>
        </el-form-item>
        <el-form-item label="流程节点">
          <FlowStepSelector
            v-model="filter.step_ids"
            :showAllChildSelect="false"
            :flow-id="filter.flow_id"
            @change="getData()"
          ></FlowStepSelector>
        </el-form-item>
        <el-form-item label="流程状态">
          <el-select v-model="filter.status" @change="getData()" size="small">
            <el-option :key="0" :value="0" label="所有"></el-option>
            <el-option :key="1" :value="1" label="已完成"></el-option>
            <el-option :key="2" :value="2" label="未完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计年份">
          <el-date-picker
            size="small"
            type="years"
            value-format="yyyy"
            v-model="filter.years"
            @change="getData()"
            placeholder="可多选"
            :picker-options="pickerOptions"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="时间刻度">
          <el-radio-group
            size="mini"
            v-model="filter.date_type"
            @change="getData()"
          >
            <el-radio :label="1" border>按年</el-radio>
            <el-radio :label="2" border>按月</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="人员">
            <el-checkbox
              @change="getData()"
              v-model="filter.featrue_user"
              border
              size="mini"
              >按人员</el-checkbox
            >
          </el-form-item> -->
      </el-form>
    </div>
    <div class="flex mt-20" style="gap: 20px">
      <div style="width: 100%">
        <div style="font-weight: 500; line-height: 2">节点统计</div>
        <el-table
          size="mini"
          :data="statistics"
          stripe
          border
          :header-cell-style="{
            background: '#37717b',
            color: '#fff',
          }"
          v-loading="loading"
        >
          <el-table-column label="时间" prop="format_date" align="center">
          </el-table-column>
          <el-table-column
            label="节点名称"
            prop="step_name"
            align="center"
            min-width="120px"
          >
          </el-table-column>
          <el-table-column label="执行次数" align="center" prop="total">
            <template slot-scope="scope">
              <div
                class="text-primary pointer text-center"
                @click="
                  chartHandleEvents({
                    name: scope.row.format_date,
                    step_name: scope.row.step_name,
                    step_id: scope.row.step_id,
                  })
                "
              >
                {{ scope.row.total }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="未完成数量" align="center" prop="doing_total">
            <template slot-scope="scope">
              <div
                class="pointer text-center"
                :class="{ 'text-danger': scope.row.doing_total > 0 }"
                @click="
                  chartHandleEvents({
                    name: scope.row.format_date,
                    step_name: scope.row.step_name,
                    step_id: scope.row.step_id,
                    doing: true,
                  })
                "
              >
                {{ scope.row.doing_total }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="超时次数" align="center" prop="timeout_total">
            <template slot-scope="scope">
              <div
                class="pointer text-center"
                :class="{ 'text-danger': scope.row.timeout_total > 0 }"
                @click="
                  chartHandleEvents({
                    name: scope.row.format_date,
                    step_name: scope.row.step_name,
                    step_id: scope.row.step_id,
                    timeout: true,
                  })
                "
              >
                {{ scope.row.timeout_total }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="平均耗时(工作日)"
            prop="avg_day"
          >
            <template slot-scope="scope">
              <span
                :class="{
                  'text-danger': scope.row.avg_day > scope.row.wait_time,
                }"
              >
                {{ scope.row.avg_day }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="标准耗时(工作日)"
            prop="wait_time"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- <div style="width: 50%">
        <div>
          <div class="chart-filter">
            <div class="item-list">
              <el-tag
                v-for="item in steps"
                :key="item"
                size="small"
                class="pointer"
                @click="updateChartData(item)"
                :effect="step == item ? 'light' : 'plain'"
                :type="step == item ? 'primary' : 'info'"
                >{{ item }}</el-tag
              >
            </div>
          </div>
          <div v-if="filter.featrue_user" class="chart-filter">
            <div class="item-list">
              <el-tag
                v-for="item in users"
                :key="item"
                size="small"
                class="pointer"
                @click="user = item"
                :effect="user == item ? 'light' : 'plain'"
                :type="user == item ? 'primary' : 'info'"
                >{{ item }}</el-tag
              >
            </div>
          </div>
        </div>
        <div style="border: 2px solid #eee; padding: 0 5px; position: relative">
          <div v-if="!filter.flow_id" class="chart-blank">请先选择流程</div>
          <ve-line
            :extend="chartData"
            :events="chartEvents"
            :colors="['#144e5a', '#E6A23C']"
            ref="chart"
          ></ve-line>
        </div>
      </div> -->
    </div>
    <div ref="flowStep">
      <div
        style="
          margin-top: 40px;
          margin-bottom: 10px;
          font-weight: 500;
          line-height: 2;
          display: flex;
          justify-content: space-between;
        "
      >
        {{ detailConditions.join('-') }}节点明细
        <el-button
          size="mini"
          type="primary"
          plain
          @click="handleExport"
          :loading="downloading"
          >导出</el-button
        >
      </div>
      <el-table
        size="mini"
        :header-cell-style="{
          background: '#37717b',
          color: '#fff',
        }"
        :data="stepList"
        stripe
        border
      >
        <el-table-column label="NCR" align="center">
          <template slot-scope="scope">
            <service-quest-link
              :id="scope.row.service_quest.id"
              :number="scope.row.service_quest.number"
              routePath="/dashboard/service_quests/list"
              target="_blank"
            ></service-quest-link>
          </template>
        </el-table-column>
        <el-table-column
          label="最终客户"
          align="center"
          prop="service_quest.customer.name"
          min-width="200px"
        >
        </el-table-column>
        <el-table-column
          label="设备序列号"
          prop="service_quest.device.serial_number"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="执行人"
          prop="finished_user_name"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.finished_user_name ||
              scope.row.service_quest.director.name ||
              '待领取'
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="执行时间"
          prop="created_at"
          align="center"
          min-width="180px"
        >
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('yyyy-MM-DD') }}~{{
              scope.row.finished_at
                ? $time(scope.row.finished_at).format('yyyy-MM-DD')
                : '至今'
            }}
          </template>
        </el-table-column>
        <el-table-column label="完成状态" align="center">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': !scope.row.finished_user_name }">{{
              scope.row.finished_user_name ? '已完成' : '未完成'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="耗时(工作日)" prop="total_day" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_day }}
            <span
              class="text-danger"
              v-if="scope.row.total_day > scope.row.wait_time"
              >（超时{{ scope.row.total_day - scope.row.wait_time }}天）</span
            >
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <div>{{ scope.row.remark }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { serviceQuestStatistics } from '@/service/getData'
import ServiceQuestFlowSelect from '@/components/select/service_quest_flow_select'
import FlowStepSelector from './FlowStepSelector.vue'

export default {
  components: {
    ServiceQuestFlowSelect,
    FlowStepSelector,
  },
  props: {
    condition: Object,
  },
  computed: {
    chartExtend() {
      let xAxis = this.getXAxis()
      let data = new Array(xAxis.length).fill(0)
      let sery1 = {
        type: 'line',
        lineStyle: {
          width: 3,
        },
        smooth: 0.6,
        name: '执行次数',
        areaStyle: {
          opacity: 0.4,
        },
        data: this.clone(data),
      }
      let sery2 = {
        type: 'line',
        name: '超时次数',
        lineStyle: {
          width: 3,
        },
        smooth: 0.6,
        areaStyle: {
          opacity: 0.4,
        },
        data: this.clone(data),
      }
      // let sery3 = {
      //   type: 'line',
      //   name: '平均耗时',
      //   smooth: 0.6,
      //   yAxisIndex: 1,
      //   data: this.clone(data),
      // }
      // let sery4 = {
      //   type: 'line',
      //   name: '标准耗时',
      //   smooth: 0.6,
      //   yAxisIndex: 1,
      //   data: this.clone(data),
      // }

      this.statistics
        .filter(
          (sta) =>
            sta.step_name == this.step &&
            (!this.filter.featrue_user ||
              (this.filter.featrue_user &&
                sta.finished_user_name == this.user)),
        )
        .map((item) => {
          let index = xAxis.indexOf(item.format_date)
          sery1.data[index] = item.total
          sery2.data[index] = item.timeout_total
          // sery3.data[index] = item.avg_day
          // sery4.data[index] = item.wait_time
        })

      return {
        // title: {
        //   text: '节点次数与耗时',
        //   left: 'center',
        // },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['执行次数', '超时次数'],
          bottom: '10px',
          icon: 'circle',
        },
        xAxis: {
          data: xAxis,
        },
        yAxis: [
          {
            splitLine: { lineStyle: { type: 'dashed' } },
            name: '次数',
            value: 'value',
            minInterval: 1,
          },
          // {
          //   splitLine: { lineStyle: { type: 'dashed' } },
          //   name: '耗时(工作日)',
          //   value: 'value',
          //   minInterval: 1,
          //   offset: -10,
          // },
        ],
        series: [sery1, sery2],
      }
    },

    steps() {
      let steps = []
      this.statistics.map((sta) => {
        if (!steps.includes(sta.step_name)) {
          steps.push(sta.step_name)
        }
      })
      // if (!this.step || !steps.find((s) => s == this.step)) {
      //   this.step = steps[0] || ''
      // }
      return steps
    },

    users() {
      let users = []
      if (this.filter.featrue_user) {
        this.statistics.map((sta) => {
          if (!users.includes(sta.finished_user_name)) {
            users.push(sta.finished_user_name)
          }
        })
      }

      if (!this.user || !users.find((u) => u == this.user)) {
        this.user = users[0] || ''
      }
      return users
    },
  },
  mounted() {
    // let that = this
    // this.$refs.chart.echarts.on('showTip', function (res) {
    //   if (res.dataIndex != that.xAxis) {
    //     that.xAxis = res.dataIndex
    //   }
    // })
    // this.$refs.chart.echarts.getZr().on('click', function (params) {
    //   that.chartHandleEvents({ name: that.getXAxis()[that.xAxis] })
    // })
  },
  data() {
    return {
      loading: false,
      statistics: [],
      stepList: [],
      filter: {
        flow_id: null,
        step_ids: [],
        featrue_type: 2, //统计维度
        date_type: 1, //时间颗粒度
        featrue_user: false,
        years: [new Date().getFullYear().toString()],
        status: 0,
      },
      years: [],
      step: '',
      user: '',
      pickerOptions: {},
      chartEvents: {
        click: this.chartHandleEvents,
      },
      detailConditions: [],
      downloading: false,
      chartData: {},
    }
  },
  created() {
    if (this.condition && this.condition.flow_id) {
      Object.assign(this.filter, this.condition)
      this.getData()
    }
    let that = this
    this.pickerOptions = {
      disabledDate: function (time) {
        return (
          that.$time(new Date()).isBefore(time) ||
          that.$time(time).isBefore('2025-01-01')
        )
      },
    }
  },
  methods: {
    getXAxis() {
      let rowNames = []
      for (let index = 0; index < this.years.length; index++) {
        const year = this.years[index]
        if (year > new Date().getFullYear()) {
          break
        }
        if (this.filter.date_type == 1) {
          rowNames.push(year)
        } else {
          for (let idx = 1; idx <= 12; idx++) {
            let month = idx < 10 ? `0${idx}` : idx.toString()
            let name = year + '-' + month
            rowNames.push(name)
            if (name == this.$time(new Date()).format('YYYY-MM')) {
              break
            }
          }
        }
      }
      return rowNames
    },

    async chartHandleEvents(e) {
      let date = e.name
      if (e.step_name) {
        this.step = e.step_name
      }
      if (date.split('-').length == 2) {
        date = date.replace('-', '年')
        date += '月'
      } else {
        date += '年'
      }
      this.detailConditions = [date, `${this.step}`]
      let res = await serviceQuestStatistics({
        featrue_type: 3,
        date: e.name,
        date_type: this.filter.date_type,
        flow_id: this.filter.flow_id,
        step_name: this.step,
        step_id: e.step_id || 0,
        status: this.filter.status,
      })

      let data = res.data
      if (e.timeout) {
        data = data.filter((item) => item.total_day > item.wait_time)
      } else if (e.doing) {
        data = data.filter((item) => !item.finished_user_name)
      }
      this.stepList = data
      this.$refs.flowStep.scrollIntoView(true)
    },

    async getData() {
      if (!this.filter.flow_id) {
        this.$alert('请选择流程!')
        return
      }

      if (this.filter.years.length == 0) {
        this.$alert('请至少选择一个年份!')
        return
      }
      this.filter.years.sort()
      let data = this.clone(this.filter)
      if (data.step_ids.length > 0) {
        data.step_id = data.step_ids[data.step_ids.length - 1]
      } else {
        delete data.step_id
      }
      this.loading = true
      let res = await serviceQuestStatistics(data)
      if (res.code == 0) {
        this.years = this.filter.years
        this.statistics = res.data
        this.detailConditions = []
        this.stepList = []
        this.updateChartData()
      }
      this.loading = false
    },

    updateChartData(stepName = '') {
      let xAxis = this.getXAxis()
      let data = new Array(xAxis.length).fill(0)
      let sery1 = {
        type: 'line',
        lineStyle: {
          width: 3,
        },
        smooth: 0.6,
        name: '执行次数',
        areaStyle: {
          opacity: 0.4,
        },
        data: this.clone(data),
      }
      let sery2 = {
        type: 'line',
        name: '超时次数',
        lineStyle: {
          width: 3,
        },
        smooth: 0.6,
        areaStyle: {
          opacity: 0.4,
        },
        data: this.clone(data),
      }
      this.step = stepName || this.steps[0]
      this.statistics
        .filter(
          (sta) =>
            sta.step_name == this.step &&
            (!this.filter.featrue_user ||
              (this.filter.featrue_user &&
                sta.finished_user_name == this.user)),
        )
        .map((item) => {
          let index = xAxis.indexOf(item.format_date)
          sery1.data[index] = item.total
          sery2.data[index] = item.timeout_total
        })

      this.chartData = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['执行次数', '超时次数'],
          bottom: '10px',
          icon: 'circle',
        },
        xAxis: {
          data: xAxis,
        },
        yAxis: [
          {
            splitLine: { lineStyle: { type: 'dashed' } },
            name: '次数',
            value: 'value',
            minInterval: 1,
          },
        ],
        series: [sery1, sery2],
      }
    },

    handleExport() {
      if (this.downloading) return
      this.downloading = true
      import('@/vendor/Export2Excel').then((excel) => {
        let tHeader = [
          'NCR',
          '最终客户',
          '设备序列号',
          '执行人',
          '开始时间',
          '完成时间',
          '完成状态',
          '耗时(工作日)',
          '超时(工作日)',
          '备注',
        ]

        let data = []
        this.stepList.map((item) => {
          let rowData = [
            item.service_quest.number || '-',
            item.service_quest.customer.name,
            item.service_quest.device.serial_number,
            item.finished_user_name ||
              item.service_quest.director.name ||
              '待领取',
            this.$time(item.created_at).format('yyyy-MM-DD'),
            item.finished_at
              ? this.$time(item.finished_at).format('yyyy-MM-DD')
              : '-',
            item.finished_user_name ? '已完成' : '未完成',
            item.total_day,
            item.total_day > item.wait_time
              ? item.total_day - item.wait_time
              : '',
            item.remark,
          ]
          data.push(rowData)
        })

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${this.detailConditions.join('-')}流程明细`,
        })
        this.downloading = false
      })
    },
  },
}
</script>

<style scoped>
.chart-filter {
  display: flex;
  margin-bottom: 5px;
  font-size: 14px;
}

.item-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.chart-blank {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 10;
  font-size: 14px;
  color: #999;
}
</style>

<style>
.hide-footer .el-picker-panel__footer {
  display: none;
}
</style>
